import React from 'react';
import styles from './LoadingIndicator.module.css';

export const LoadingIndicator = ({ size = 'medium', color = 'primary', centered = false }) => {
  const sizeClass = {
    small: styles.small,
    medium: styles.medium,
    large: styles.large
  }[size];
  
  const colorClass = {
    primary: styles.primary,
    light: styles.light,
    dark: styles.dark
  }[color];
  
  const containerClass = centered ? styles.centered : '';
  
  return (
    <div className={containerClass}>
      <div className={`${styles.spinner} ${sizeClass} ${colorClass}`}>
        <div className={styles.bounce1}></div>
        <div className={styles.bounce2}></div>
        <div className={styles.bounce3}></div>
      </div>
    </div>
  );
};
